// extracted by mini-css-extract-plugin
export var contentBody = "_di-9";
export var headerImage = "_di-2";
export var imageButton = "_di-7";
export var imageButtonIcon = "_di-8";
export var imageHeader = "_di-4";
export var imageHeaderText = "_di-5";
export var imageOverlay = "_di-3";
export var imageTitle = "_di-6";
export var imageWrapper = "_di-1";
export var taskList = "_di-a";
export var widget = "_di-0";